import { AppContext } from "domains/commons/contexts/global/global-provider";
import { NEW_PLAN_ACTION } from "domains/commons/contexts/global/staticData";
import { DataLayer } from "libs/providers/datalayer/datalayer";
import { useContext } from "react";
import { getAutoefectivoName } from "../utils/datalayer";
import { useLocation } from "react-router-dom";


export const useAllPlansTable = () => {
    const { actions } = useContext(AppContext);
    const location = useLocation();
    const { pathname } = location;
    const name = getAutoefectivoName(pathname)

    const handleSelectedPlan = (plan: string) => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });

        actions.dispatchNewPlan({ type: NEW_PLAN_ACTION.set, payload: plan })
        DataLayer.setVirtualEvent({
            category: `Seguro Vehicular - Plan Auto Efectivo ${name} Leads`,
            action: 'Inicio',
            label: `Click – Botón - ${plan}`,
            flujo: `${plan}`,
            tipoZona: 'Autos',
            zona: `PlanAutoefectivo${name}Leads`,
            subZona: 'Inicio',
            sección: 'Formulario',
            tipoEvento: 'click',
            tipoElemento: 'Botón',
            valor: `${plan} `
        });
    }

    return {
        handleSelectedPlan
    }
}